export default function WhyMuslimFriendly() {
  const features = [
    {
      icon: 'ri-restaurant-2-line',
      title: 'Halal Dining',
      description: 'Certified halal restaurants, hotels with halal breakfast, and local Muslim-owned eateries in every destination.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Family Safety',
      description: 'Low crime rates, family-friendly public spaces, and destinations known for welcoming tourists with children.',
    },
    {
      icon: 'ri-ancient-pavilion-line',
      title: 'Prayer Facilities',
      description: 'Easy access to mosques, prayer rooms in hotels and airports, and Qibla direction assistance.',
    },
    {
      icon: 'ri-heart-3-line',
      title: 'Cultural Comfort',
      description: 'Muslim-majority or Muslim-friendly cultures where modest dress and Islamic values are respected and understood.',
    },
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-[#1A1F2E] mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Why Choose Muslim-Friendly Destinations
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Travel with confidence knowing your family's needs are fully catered for
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center p-8 bg-gradient-to-b from-gray-50 to-white rounded-2xl border border-gray-100 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-[#14B8A6] rounded-full mb-6 shadow-lg">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-[#1A1F2E] mb-3">{feature.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}